import { useMemo } from 'react';
import { HeartPulse } from 'lucide-react';

import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import { enrolmentHealthFilterOptions } from '@duke-hq/ui/components/EnrolmentHealthBadge/constants';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

export default function HealthFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const options = enrolmentHealthFilterOptions.map(({ key, label }) => ({
    id: key,
    value: key,
    label,
  }));

  const selected = useMemo(() => {
    const health = filters.health ?? [];
    const validIds = new Set(options.map(({ id }) => id));
    return health.filter((id) => validIds.has(id));
  }, [filters.health, options]);

  return (
    <MultipleChoiceFilter
      items={options}
      label="Health"
      name="health"
      onFilterChange={({ health }) => updateFilters({ health })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<HeartPulse size="16px" />}
      rightIcon={undefined}
    />
  );
}
